var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrameK(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41524_1399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0028 1.10547C7.75447 1.10547 1.07031 7.79091 1.07031 16.0373C1.07031 24.2837 7.75447 30.97 16.0028 30.97C24.2512 30.97 30.9366 24.2837 30.9366 16.0373C30.9366 7.79091 24.2512 1.10547 16.0028 1.10547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.16374 0 0 7.16342 0 16C0 24.8366 7.16374 32 16 32C24.8363 32 32 24.8366 32 16C32 7.16342 24.8363 0 16 0ZM10.224 20.4656H7.01381C6.82034 20.4656 6.67597 20.3785 6.59478 20.2463C6.50967 20.1094 6.50541 19.9313 6.59478 19.7542L10.0046 13.7356C10.0086 13.7287 10.0086 13.7248 10.0046 13.7173L7.83452 9.9601C7.74515 9.78136 7.73172 9.60491 7.81618 9.46774C7.89803 9.33516 8.0604 9.2674 8.25387 9.2674H11.464C11.9564 9.2674 12.1976 9.58461 12.3574 9.86909C12.3574 9.86909 14.5511 13.6957 14.5642 13.7173C14.4345 13.9464 11.0993 19.8452 11.0993 19.8452C10.935 20.1412 10.7039 20.4656 10.224 20.4656ZM25.4023 5.57242L18.2955 18.138C18.2906 18.1449 18.2906 18.1528 18.2955 18.1586L22.82 26.4263C22.9091 26.6047 22.9117 26.7857 22.8269 26.9226C22.7457 27.0542 22.5941 27.1278 22.4007 27.1278H19.1944C18.7027 27.1278 18.4569 26.8008 18.2981 26.5166C18.2981 26.5166 13.749 18.1711 13.7372 18.1488C13.9644 17.7465 20.8791 5.48338 20.8791 5.48338C21.0509 5.17434 21.2595 4.87218 21.7384 4.87218H24.9813C25.1744 4.87218 25.326 4.94519 25.4078 5.07712C25.4933 5.21428 25.4907 5.39499 25.4023 5.57242Z",
    fill: "#2B2B2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41524_1399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameK);
export default __webpack_public_path__ + "static/media/FrameK.cda789b05eb04b1fa25bb953b7d92af4.svg";
export { ForwardRef as ReactComponent };